import React from "react"
import * as styles from "./video.module.css"

const getURL = (type, id, autoplay) => {
  if (type === "youtube") return `https://www.youtube-nocookie.com/embed/${id}?autoplay=${autoplay ? "1" : "0"}`
}

export default ({ type, id, autoplay = false, mode = "normal" }) => {
  return (
    <div className={`${styles.wrapper} ${styles[mode]}`}>
      <iframe
        className={styles.frame}
        src={getURL(type, id, autoplay)}
        title="Video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  )
}
